import React from 'react';
import './SaveQueueStatus.css';

const SaveQueueStatus = ({ saveQueue, darkMode }) => {
  if (saveQueue.length === 0) return null;

  const pendingItems = saveQueue.filter(item => item.status === 'pending');
  const savingItems = saveQueue.filter(item => item.status === 'saving');
  const successItems = saveQueue.filter(item => item.status === 'success');
  const errorItems = saveQueue.filter(item => item.status === 'error');


  const completedCount = successItems.length + errorItems.length;
  const totalCount = saveQueue.length;

  // If there's only one item, show detailed view
  if (totalCount === 1) {
    const item = saveQueue[0];
    const { status, product, message, storeCount, warning } = item;
    const sku = product?.sku || 'Unknown SKU';

    return (
      <div className={`save-queue-status ${darkMode ? 'dark' : 'light'}`}>
        <div className={`queue-item single status-${status}`}>
          {status === 'pending' && (
            <div className="status-content">
              <span className="spinner">⏳</span>
              <span className="text">Queued: {sku}</span>
            </div>
          )}
          {status === 'saving' && (
            <div className="status-content">
              <span className="spinner rotating">⚙️</span>
              <span className="text">Saving {sku}...</span>
            </div>
          )}
          {status === 'success' && (
            <div className="status-content success">
              <span className="icon">✅</span>
              <span className="text">{sku} saved to {storeCount} store(s)</span>
              {warning && <span className="text warning" title={warning}> · Shopify packed size not updated</span>}
            </div>
          )}
          {status === 'error' && (
            <div className="status-content error">
              <span className="icon">❌</span>
              <span className="text">{sku} failed: {message}</span>
            </div>
          )}
        </div>
      </div>
    );
  }

  // Multiple items - show consolidated progress
  const currentSaving = savingItems[0]?.product?.sku || pendingItems[0]?.product?.sku;
  const progress = totalCount > 0 ? Math.round(((completedCount) / totalCount) * 100) : 0;

  return (
    <div className={`save-queue-status ${darkMode ? 'dark' : 'light'}`}>
      <div className="queue-item consolidated">
        <div className="status-content">
          <span className="spinner rotating">⚙️</span>
          <div className="progress-info">
            <span className="text">
              Saving {completedCount + 1} of {totalCount} products
              {currentSaving && <span className="current-sku"> ({currentSaving})</span>}
            </span>
            <div className="progress-bar-container">
              <div className="progress-bar" style={{ width: `${progress}%` }} />
            </div>
            {errorItems.length > 0 && (
              <span className="error-count">⚠️ {errorItems.length} error(s)</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SaveQueueStatus;
